import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd0df83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex content" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title" }, " 样式库：", -1))
const _hoisted_5 = { class: "form_cont flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "code" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title" }, "logo设置：", -1))
const _hoisted_11 = { class: "logo_box" }
const _hoisted_12 = {
  key: 0,
  class: "flex",
  style: {"margin-top":"10px","align-items":"center"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("建议尺寸：300px * 300px，小于2M，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持JPG、GIF、PNG、BMP格式。")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "flex mar"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title" }, "颜色设置：", -1))
const _hoisted_16 = { class: "logo_box flex" }
const _hoisted_17 = { class: "color_box flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "优选颜色：", -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "sel_color flex" }
const _hoisted_21 = {
  key: 1,
  class: "flex mar"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title" }, "logo效果：", -1))
const _hoisted_23 = { class: "logo_box" }
const _hoisted_24 = { class: "save" }
const _hoisted_25 = { class: "right" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview_title" }, "预览", -1))
const _hoisted_27 = { class: "preview" }
const _hoisted_28 = { class: "flex mar" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title2" }, "容错：", -1))
const _hoisted_30 = { class: "flex mar" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title2" }, "边距：", -1))
const _hoisted_32 = {
  class: "flex mar",
  style: {"margin-bottom":"20px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form_title2" }, "尺寸：", -1))
const _hoisted_34 = { class: "form_qrcode" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "base_qrcode" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "mar download" }

import { computed, ref } from 'vue';
import { Radio, Select, InputNumber, message, Popover } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import { code1, code2, code3, code4, code5, code6, code7, code8 } from '@/assets';
import { ArrowDownOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
import { useLiveStore } from '@/pinia/live';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import vueQr from 'vue-qr/src/packages/vue-qr.vue';
import http from '@/api';
import { useRoute } from 'vue-router';
import { qrData } from './broadCast';
import domtoimage from 'dom-to-image';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BeautifyCode',
  setup(__props) {

const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aSelect = Select;
const aSelectOption = Select.Option;
const aInputNumber = InputNumber;
const aPopover = Popover;
const cssList = [
  { key: 1, name: '标准', color: '#00CCB0', background: '#ccf5ef', url: code1 },
  { key: 2, name: '方块', color: '#FFB300', background: '#FFFDE8', url: code2 },
  { key: 3, name: '古风', color: '#d1241b', background: '#f5d6d5', url: code3 },
  { key: 4, name: '聚焦', color: '#F06292', background: '#FFEBEE', url: code4 },
  { key: 5, name: '轻绿', color: '#74C69D', background: '#D8F3DC', url: code5 },
  { key: 6, name: '海蓝', color: '#17BAD4', background: '#D0F1F7', url: code6 },
  { key: 7, name: '多彩', color: '#FFB300', background: '#FFFDE4', url: code7 },
  { key: 8, name: '渐变', color: '#74C69D', background: '#EFFFF2', url: code8 },
];
const route = useRoute();
const studioId = computed(() => route.params.studioId);
const resData = ref<qrData>({});
const getCodeData = () => {
  http.code.getData({ params: { studio_id: studioId.value } }).then((res) => {
    resData.value = res.data.data;
    clickStyle(resData.value.style_id ? resData.value.style_id : 1);
    groupShape.value = res.data.data.qr_code_shape;
    changeShape();
    groupLogo.value = res.data.data.logo_type;
    changeUrl();
    res.data.data.resolution ? (resolvPower.value = res.data.data.resolution) : '';
    color.value = res.data.data.qr_code_color ? res.data.data.qr_code_color : '#000000';
    res.data.data.margin ? (margin.value = res.data.data.margin) : '';
    res.data.data.custom_icon_url ? (vueQrData.logoSrc = logoUrl.value = res.data.data.custom_icon_url) : '';
    imgId.value = res.data.data.custom_icon;
    options1.forEach((element: any, index: number) => {
      if (element.label === res.data.data.fault_tolerance) {
        errorRate.value = index;
        errorCorrectionLevel.value = element.value;
      }
    });
  });
};
getCodeData();

const codeKey = ref(1);
const clickStyle = (key: any) => {
  switch (key) {
    case 1:
      color.value = '#000000';
      codeKey.value = 1;
      vueQrData.dotScale = 1;
      break;
    case 2:
      color.value = '#5278ad';
      codeKey.value = 2;
      vueQrData.dotScale = 0.7;
      break;
    case 3:
      color.value = '#ac1c15';
      codeKey.value = 3;
      vueQrData.dotScale = 1;
      break;
    case 4:
      color.value = '#000000';
      codeKey.value = 4;
      vueQrData.dotScale = 1;
      break;
    case 5:
      color.value = '#00ccb0';
      codeKey.value = 5;
      vueQrData.dotScale = 1;
      break;
    case 6:
      color.value = '#2B65AD';
      codeKey.value = 6;
      vueQrData.dotScale = 1;
      break;
    case 7:
      color.value = '#000000';
      codeKey.value = 7;
      vueQrData.dotScale = 1;
      break;
    case 8:
      color.value = '#000000';
      codeKey.value = 8;
      vueQrData.dotScale = 0.8;
      break;
  }
};
const groupLogo = ref<any>(0); //logo设置单选框value值
const changeUrl = () => {
  switch (groupLogo.value) {
    case 0:
      vueQrData.logoSrc = '';
      imageDel();
      break;
    case 3:
      vueQrData.logoSrc = '';
      break;
    case 2:
      vueQrData.logoSrc = resData.value.avatar_url;
      imageDel();
      break;
    case 1:
      vueQrData.logoSrc = resData.value.logo_url;
      imageDel();
      break;
  }
};
const groupShape = ref<any>(0); //码型设置单选框value值
const changeShape = () => {
  if (groupShape.value === 0) {
    vueQrData.logoCornerRadius = 0;
    vueQrData.logoCornerRadiusD = 0;
  } else if (groupShape.value === 1) {
    vueQrData.logoCornerRadius = 8;
    vueQrData.logoCornerRadiusD = 12;
  } else {
    vueQrData.logoCornerRadius = 20;
    vueQrData.logoCornerRadiusD = 25;
    if (resolvPower.value === 600) {
      vueQrData.logoCornerRadiusD = 52;
    }
    if (resolvPower.value === 1200) {
      vueQrData.logoCornerRadiusD = 110;
    }
  }
};
const colorList = ref(['#00CCb0', '#1890FF', '#FF4D4F', '#FF9337']);
const color = ref<any>('#000000');

const clickSelColor = (item: any) => {
  color.value = item;
};

const changeColor = (item: any) => {
  color.value = item;
};

const errorRate = ref(0); // 容错率
const options1: any = [
  { value: 1, label: '7%', correctLevel: 'L' },
  { value: 0, label: '15%', correctLevel: 'M' },
  { value: 3, label: '25%', correctLevel: 'Q' },
  { value: 2, label: '30%', correctLevel: 'H' },
];
const changeError = (el: any) => {
  errorCorrectionLevel.value = options1[el].value;
};

const margin = ref(10); //边距设置

const resolvPower = ref<any>(300); //分辨率
const options2 = [
  { value: 300, label: '300px' },
  { value: 600, label: '600px' },
  { value: 1200, label: '1200px' },
];
const changeSize = (el: number) => {
  if (el === 600 && groupShape.value === 3) {
    vueQrData.logoCornerRadiusD = 52;
  }
  if (el === 1200 && groupShape.value === 3) {
    vueQrData.logoCornerRadiusD = 110;
  }
};
const liveStore = useLiveStore();
const qrcodeUrl = computed(() => liveStore.liveInfo.qr_code_url); //二维码url
const errorCorrectionLevel = ref<any>();
const qrcodeRef = ref();

const fileList = ref([]);
const loading = ref(false);
const logoUrl = ref('');
const imgId = ref();
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    logoUrl.value = info.file?.response?.data.url;
    imgId.value = info.file?.response?.data.id;
    vueQrData.logoSrc = logoUrl.value;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
};
const imageDel = () => {
  logoUrl.value = '';
  imgId.value = '';
};

const vueQrData = {
  text: qrcodeUrl.value,
  logoSrc: resData.value.logo_url,
  logoBackgroundColor: '#fff', //当logoMargin不为0时，空白区域的颜色
  logoMargin: 2, //	logo距离周边的位置，默认为0
  bgSrc: '', //二维码背景图，通常和dotScale搭配使用
  dotScale: 1, //二维码数据点的速率比
  logoCornerRadius: -2,
  logoCornerRadiusD: -2,
  bgcale: 0.8, //背景图的速率比
};

const toImage = (key: number) => {
  domtoimage
    .toPng(qrcodeRef.value)
    .then((dataUrl) => {
      if (key === 1) {
        download(dataUrl);
      } else {
        setSave(dataUrl);
      }
    })
    .catch((error) => {
      console.error('oops, something went wrong!', error);
    });
};

const download = (url: string) => {
  // canvas.toBlob((blob: any) => {
  //   URL.createObjectURL(blob);
  // const obj = resolvPower.value + 'px';
  // const px = obj.substring(0, obj.length - 2);
  //   .then((dataUrl: any) => {
  //     let a = document.createElement('a');
  //     let img = new Image();
  //     img.src = dataUrl;
  //     a.href = img.src;
  //     a.download = 'code';
  //     a.click();
  //   })
  var img = new Image();
  img.src = url;
  let a = document.createElement('a');
  a.href = img.src;
  a.download = `code_${studioId.value}`;
  a.click();
};

const setSave = (url: string) => {
  const data = {
    studio_id: studioId.value,
    qr_code_url: url,
    logo_type: groupLogo.value, //logo类型 0.不使用logo；1.频道logo；2.账号logo；3.自定义上传
    margin: margin.value, //边距
    fault_tolerance: options1[errorRate.value].label, //容错率
    qr_code_shape: groupShape.value, //logo形状
    qr_code_color: color.value, //二维码颜色
    style_id: codeKey.value, // 样式ID（样式库的样式ID）
    resolution: resolvPower.value, //分辨率
    custom_icon: imgId.value,
  };
  http.code
    .setCode(data)
    .then((res: any) => {
      message.success(res.data.message);
      getLiveInfo();
    })
    .catch((error) => {
      console.error(error);
    });
};

const getLiveInfo = async () => {
  const resData = await http.live.getLiveInfo({
    params: { studio_id: studioId.value },
  });
  liveStore.liveInfo = resData.data.data;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cssList, (i) => {
            return _createElementVNode("div", {
              key: i.key,
              style: _normalizeStyle({ background: i.background }),
              class: "code_box",
              onClick: ($event: any) => (clickStyle(i.key))
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({ color: i.color })
              }, _toDisplayString(i.name), 5),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: i.url
                }, null, 8, _hoisted_8)
              ])
            ], 12, _hoisted_6)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: groupLogo.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((groupLogo).value = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (changeUrl()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("频道logo")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode("帐号头像")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode("自定义")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("不使用")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (groupLogo.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(CUpload, {
                  "file-list": fileList.value,
                  "image-name": logoUrl.value,
                  loading: loading.value,
                  "handle-change": (info) => handleChange(info),
                  "click-stop": imageDel
                }, null, 8, ["file-list", "image-name", "loading", "handle-change"]),
                _createTextVNode("   "),
                _createVNode(_unref(aPopover), { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_13
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionCircleFilled))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (codeKey.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (i, o) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "built_color",
                    key: o,
                    style: _normalizeStyle({ background: i }),
                    onClick: ($event: any) => (clickSelColor(i))
                  }, null, 12, _hoisted_19))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", null, _toDisplayString(color.value), 1),
                _createVNode(_unref(ElColorPicker), {
                  modelValue: color.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((color).value = $event)),
                  predefine: colorList.value,
                  size: "mini",
                  onChange: changeColor
                }, null, 8, ["modelValue", "predefine"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (groupLogo.value !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(aRadioGroup), {
                name: "radioGroup",
                value: groupShape.value,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((groupShape).value = $event)),
                onChange: changeShape
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("方形")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("圆角矩形")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("圆形")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toImage(2))),
          style: {"width":"79px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_unref(aSelect), {
            value: errorRate.value,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((errorRate).value = $event)),
            style: {"width":"140px"},
            onChange: changeError
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options1, (i, o) => {
                return _createVNode(_unref(aSelectOption), { key: o }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(i.label), 1)
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_unref(aInputNumber), {
            style: {"width":"120px"},
            value: margin.value,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((margin).value = $event)),
            min: 0,
            max: 50
          }, null, 8, ["value"]),
          _createTextVNode("  PX ")
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode(_unref(aSelect), {
            value: resolvPower.value,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((resolvPower).value = $event)),
            style: {"width":"140px"},
            options: options2,
            onChange: changeSize
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", {
            ref_key: "qrcodeRef",
            ref: qrcodeRef,
            class: "form_qrcode_box"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["preview_code", {
                g_container: codeKey.value === 7,
                b_container: codeKey.value === 3,
                s_container: codeKey.value === 8,
                k_container: codeKey.value === 4,
              }]),
              style: _normalizeStyle({
                height: resolvPower.value + 'px',
                width: resolvPower.value + 'px',
                padding: `${
                  resolvPower.value === 1200 && (codeKey.value === 3 || codeKey.value === 4)
                    ? '120px'
                    : resolvPower.value === 600 && (codeKey.value === 3 || codeKey.value === 4)
                    ? '60px'
                    : resolvPower.value === 300 && (codeKey.value === 3 || codeKey.value === 4)
                    ? '30px'
                    : ''
                }`,
              })
            }, [
              _createVNode(vueQr, {
                text: vueQrData.text,
                bgSrc: vueQrData.bgSrc,
                logoSrc: vueQrData.logoSrc,
                logoBackgroundColor: vueQrData.logoBackgroundColor,
                logoMargin: vueQrData.logoMargin,
                dotScale: vueQrData.dotScale,
                logoCornerRadius: vueQrData.logoCornerRadiusD,
                bgcale: vueQrData.bgcale,
                margin: margin.value,
                correctLevel: errorCorrectionLevel.value,
                colorDark: color.value,
                size: resolvPower.value,
                whiteMargin: true
              }, null, 8, ["text", "bgSrc", "logoSrc", "logoBackgroundColor", "logoMargin", "dotScale", "logoCornerRadius", "bgcale", "margin", "correctLevel", "colorDark", "size"]),
              ((codeKey.value === 7 || codeKey.value === 8) && vueQrData.logoSrc)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: vueQrData.logoSrc,
                    class: _normalizeClass(["logo", { logo_shape1: groupShape.value === 2, logo_shape2: groupShape.value === 1 }])
                  }, null, 10, _hoisted_35))
                : _createCommentVNode("", true)
            ], 6)
          ], 512)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", {
            class: _normalizeClass(["preview_code", {
              g_container: codeKey.value === 7,
              b_container: codeKey.value === 3,
              s_container: codeKey.value === 8,
              k_container: codeKey.value === 4,
            }])
          }, [
            _createVNode(vueQr, {
              text: vueQrData.text,
              bgSrc: vueQrData.bgSrc,
              logoSrc: vueQrData.logoSrc,
              logoBackgroundColor: vueQrData.logoBackgroundColor,
              logoMargin: vueQrData.logoMargin,
              dotScale: vueQrData.dotScale,
              logoCornerRadius: vueQrData.logoCornerRadius,
              bgcale: vueQrData.bgcale,
              margin: margin.value,
              correctLevel: errorCorrectionLevel.value,
              colorDark: color.value,
              size: 195,
              whiteMargin: true
            }, null, 8, ["text", "bgSrc", "logoSrc", "logoBackgroundColor", "logoMargin", "dotScale", "logoCornerRadius", "bgcale", "margin", "correctLevel", "colorDark"]),
            ((codeKey.value === 7 || codeKey.value === 8) && vueQrData.logoSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: vueQrData.logoSrc,
                  class: _normalizeClass(["logo", { logo_shape1: groupShape.value === 2, logo_shape2: groupShape.value === 1 }])
                }, null, 10, _hoisted_37))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_a_button, {
            class: "line_box",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (toImage(1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowDownOutlined)),
              _createTextVNode("下载")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})